(function () {
  'use strict';

  // ── TOAST MESSAGE — edit this text if you want ─────────────
  var TOAST_MESSAGE = '🎉 You\'ve unlocked free shipping — enjoy!';
  // ───────────────────────────────────────────────────────────

  var SESSION_KEY   = 'fsb_unlocked';
  var _fetchPatched = false;

  var FreeShippingBar = {

    init: function () {
      this.animateFills();
      this.checkToast();
    },

    animateFills: function () {
      var fills = document.querySelectorAll('.free-shipping-bar__fill');
      fills.forEach(function (fill) {
        var progress = Math.min(parseFloat(fill.dataset.progress || 0), 100);
        fill.style.width = '0%';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            fill.style.width = progress + '%';
          });
        });
      });
    },

    checkToast: function () {
      var bar = document.querySelector('.free-shipping-bar');
      if (!bar) return;

      var threshold  = parseInt(bar.dataset.threshold || 0, 10);
      var cartTotal  = parseInt(bar.dataset.cartTotal  || 0, 10);

      if (threshold === 0) return;

      var isUnlocked   = cartTotal >= threshold;
      var alreadyShown = sessionStorage.getItem(SESSION_KEY) === '1';

      if (isUnlocked && !alreadyShown) {
        var self = this;
        setTimeout(function () { self.showToast(); }, 700);
        sessionStorage.setItem(SESSION_KEY, '1');
      }

      if (!isUnlocked) {
        sessionStorage.removeItem(SESSION_KEY);
      }
    },

    showToast: function () {
      var existing = document.getElementById('FsbToast');
      if (existing) existing.remove();

      var toast = document.createElement('div');
      toast.id = 'FsbToast';
      toast.className = 'fsb-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<span class="fsb-toast__icon">🎉</span>' +
        '<span class="fsb-toast__text">' + TOAST_MESSAGE + '</span>' +
        '<button class="fsb-toast__close" aria-label="Close">&times;</button>';

      document.body.appendChild(toast);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          toast.classList.add('fsb-toast--visible');
        });
      });

      function dismiss() {
        toast.classList.add('fsb-toast--hiding');
        toast.classList.remove('fsb-toast--visible');
        setTimeout(function () { if (toast.parentNode) toast.remove(); }, 350);
      }

      var autoTimer = setTimeout(dismiss, 4500);
      toast.querySelector('.fsb-toast__close').addEventListener('click', function () {
        clearTimeout(autoTimer);
        dismiss();
      });
    },

    updateFromCart: function (cartData) {
      var bars = document.querySelectorAll('.free-shipping-bar');
      if (!bars.length) return;
      var totalCents = cartData.total_price;
      var self = this;

      bars.forEach(function (bar) {
        var threshold  = parseInt(bar.dataset.threshold || 0, 10);
        if (threshold === 0) return;

        var progress   = Math.min(Math.round((totalCents / threshold) * 100), 100);
        var remaining  = Math.max(threshold - totalCents, 0);
        var isUnlocked = totalCents >= threshold;

        var fill = bar.querySelector('.free-shipping-bar__fill');
        if (fill) {
          fill.dataset.progress = progress;
          fill.style.width = progress + '%';
        }

        bar.dataset.cartTotal = totalCents;
        bar.classList.toggle('free-shipping-bar--unlocked', isUnlocked);

        var msgEl = bar.querySelector('.free-shipping-bar__message-text');
        if (msgEl) {
          msgEl.classList.toggle('free-shipping-bar__message-text--success', isUnlocked);

          if (isUnlocked) {
            msgEl.innerHTML = '🎉 You\'ve unlocked free shipping — enjoy!';
          } else if (totalCents === 0) {
            msgEl.innerHTML = '🚚 Spend <strong>' + self.formatMoney(threshold) + '</strong> to get free shipping';
          } else {
            msgEl.innerHTML = '🚚 You\'re <strong>' + self.formatMoney(remaining) + '</strong> away from free shipping';
          }

          var track = bar.querySelector('.free-shipping-bar__track');
          if (track) track.setAttribute('aria-valuenow', progress);
        }
      });

      this.checkToast();
    },

    formatMoney: function (cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        var fmt = window.Shopify.money_format || window.Shopify.moneyFormat || '{{amount}} EGP';
        return window.Shopify.formatMoney(cents, fmt);
      }
      return (cents / 100).toFixed(0) + ' EGP';
    },

    bindEvents: function () {
      var self = this;

      var cartSelectors = ['cart-drawer', '#CartDrawer', '#cart-drawer', '.cart-drawer', '#CartNotification'];
      cartSelectors.forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el) return;
        var observer = new MutationObserver(
          self.debounce(function () {
            self.animateFills();
            self.checkToast();
          }, 200)
        );
        observer.observe(el, { childList: true, subtree: true });
      });

      var cartEvents = ['cart:refresh', 'cart:updated', 'cart:change', 'cart:open', 'cart-drawer:open', 'shopify:section:load'];
      cartEvents.forEach(function (evt) {
        document.addEventListener(evt, function () {
          self.animateFills();
          self.checkToast();
        });
      });

      if (!_fetchPatched) {
        _fetchPatched = true;
        var originalFetch = window.fetch;

        window.fetch = function () {
          var args = Array.prototype.slice.call(arguments);
          var req  = args[0];
          var url  = typeof req === 'string' ? req : (req instanceof Request ? req.url : String(req || ''));
          var promise = originalFetch.apply(this, args);
          var isCartCall = /\/cart(\.js|\/add|\/change|\/update)(\.js)?/.test(url);

          if (isCartCall) {
            promise.then(function (response) {
              response.clone().json().then(function (data) {
                if (typeof data.total_price === 'number') {
                  self.updateFromCart(data);
                }
              }).catch(function () {});
            }).catch(function () {});
          }

          return promise;
        };
      }
    },

    debounce: function (fn, delay) {
      var timer;
      return function () {
        var ctx = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () { fn.apply(ctx, args); }, delay);
      };
    }
  };

  function boot() {
    FreeShippingBar.init();
    FreeShippingBar.bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () { FreeShippingBar.init(); });

})();